import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStoreVarientsMutation } from "../../Services/ProductAPI";
import { useGetCategoryListQuery } from "../../Services/CategoryAPI"

function Addvarients() {
    const navigate = useNavigate();
     const { productId } = useParams();
    const [varientName, setvarientName] = useState("");
    // const [categoryName, setCategoryName] = useState("");
    const [variantValues, setVariantValues] = useState([""]); // Array for dynamic fields
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);
    console.log("productId", productId)
    const [addVarients, { isLoading }] = useStoreVarientsMutation();
    const { data: allCategories } = useGetCategoryListQuery();
    const validateForm = () => {
        let newErrors = {};
        if (!varientName.trim()) newErrors.varientName = "Name is required";
        // if (!categoryName.trim()) newErrors.categoryName = "Category is required";
        if (variantValues.some(value => !value.trim())) newErrors.variantValues = "All variant fields are required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const payload = {
            name: varientName,
            // product_id:productId,
            values: variantValues,
        };

        try {
            await addVarients(payload).unwrap();
            alert("Variant added successfully!");
            setvarientName("");
            setVariantValues([""]);
            setErrors({});
            setApiError(null);
            navigate(`/list-varients`);
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    console.log("allCategories", allCategories)
    // Handle adding a new variant field
    const handleAddVariant = () => {
        setVariantValues([...variantValues, ""]);
    };

    // Handle removing a variant field
    const handleRemoveVariant = (index) => {
        const updatedVariants = [...variantValues];
        updatedVariants.splice(index, 1);
        setVariantValues(updatedVariants);
    };

    // Handle input change for variants
    // const handleVariantChange = (index, value) => {
    //     const updatedVariants = [...variantValues];
    //     updatedVariants[index] = value;
    //     setVariantValues(updatedVariants);
    // };


    const handlevarientNameChange = (e) => {
        setvarientName(e.target.value);

        // Clear validation error for category name when user types
        if (errors.varientName) {
            setErrors((prevErrors) => ({ ...prevErrors, varientName: undefined }));
        }
    };

    const handleVariantChange = (index, value) => {
        const updatedVariants = [...variantValues];
        updatedVariants[index] = value;
        setVariantValues(updatedVariants);

        // Clear validation error for variant values when user types
        if (errors.variantValues) {
            setErrors((prevErrors) => ({ ...prevErrors, variantValues: undefined }));
        }
    };

    return (
        <div>
            <h3>Add Variants</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to={`/list-varients`}><span>Variants</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">Add</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        {/* Brand Name */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_name" className="form-label">VariantName</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="category_name"
                                    placeholder="Enter VariantName"
                                    value={varientName}
                                    onChange={handlevarientNameChange}
                                />
                                {errors.varientName && <p className="text-danger">{errors.varientName}</p>}
                            </div>
                        </div>

                        {/* <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_name" className="form-label">Select Category</label><br />
                                <select onChange={handleCategoryNameChange} value={categoryName} className="form-control">
                                    <option value="">Select</option>
                                    {allCategories?.data?.map((item) => (
                                        <option value={item.id}>{item.category_name}</option>
                                    ))}
                                </select>
                                {errors.categoryName && <p className="text-danger">{errors.categoryName}</p>}
                            </div>
                        </div> */}

                    </div>

                    {/* Variant Values */}
                    <div className="row">
                        {/* Brand Name */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Variant Values</label>
                                {variantValues.map((value, index) => (
                                    <div key={index} className="d-flex mb-2">
                                        <input
                                            type="text"
                                            className="form-control me-2"
                                            placeholder={`Enter Variant ${index + 1}`}
                                            value={value}
                                            onChange={(e) => handleVariantChange(index, e.target.value)}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => handleRemoveVariant(index)}
                                            disabled={variantValues.length === 1} // Prevent removing last field
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </div>
                                ))}
                                {errors.variantValues && <p className="text-danger">{errors.variantValues}</p>}
                                <button type="button" className="btn btn-success mt-2" onClick={handleAddVariant}>
                                    <FontAwesomeIcon icon={faPlus} /> Add Variant
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* API Error Message */}
                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    {/* Submit Button */}
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div >
        </div >
    );
}

export default Addvarients;
